// submit.js

import { useState } from 'react';
import { useStore } from './store';
import { shallow } from 'zustand/shallow';

const selector = (state) => ({
  nodes: state.nodes,
  edges: state.edges,
});

export const SubmitButton = () => {
  const { nodes, edges } = useStore(selector, shallow);
  const [isLoading, setIsLoading] = useState(false);
  const handleSubmit = async () => {
    setIsLoading(true);

    try {
      const pipelineData = {
        nodes: nodes.map(node => ({
          id: node.id,
          type: node.type,
          position: node.position,
          data: node.data
        })),
        edges: edges.map(edge => ({
          id: edge.id,
          source: edge.source,
          target: edge.target,
          sourceHandle: edge.sourceHandle,
          targetHandle: edge.targetHandle
        }))
      };

      const response = await fetch('http://localhost:8000/pipelines/parse', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(pipelineData),
      });

      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }

      const data = await response.json();
      

      // Show user-friendly alert
      alert(`Pipeline Analysis Complete!\n\n📊 Nodes: ${data.num_nodes}\n🔗 Edges: ${data.num_edges}\n${data.is_dag ? '✅' : '❌'} Is DAG: ${data.is_dag ? 'Yes' : 'No'}`);

    } catch (error) {
      console.error('Error submitting pipeline:', error);
      alert(`Error submitting pipeline: ${error.message}`);
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <>
      <div className="flex items-center justify-center pb-4">
        <button
          onClick={handleSubmit}
          disabled={isLoading}
          className={`
            w-full md:w-auto px-6 md:px-8 py-3.5 md:py-4 rounded-full md:rounded-pill font-bold text-xs md:text-sm tracking-widest uppercase
            transition-all duration-500 shadow-[0_12px_48px_rgba(112,0,255,0.3)]
            flex items-center justify-center gap-3
            ${isLoading
              ? 'bg-pipeline-light text-pipeline-muted cursor-not-allowed border border-white/5'
              : 'bg-gradient-to-r from-[#7000FF] to-[#0070FF] text-white hover:scale-105 hover:shadow-[0_16px_64px_rgba(112,0,255,0.5)] active:scale-95'
            }
          `}
        >
          {isLoading ? (
            <div className="w-4 h-4 border-2 border-white/30 border-t-white rounded-full animate-spin" />
          ) : (
            <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" className="w-4 h-4">
              <path d="M5 12h14m-7-7l7 7-7 7" />
            </svg>
          )}
          {isLoading ? 'Analyzing...' : 'Deploy Pipeline'}
        </button>
      </div>
    </>
  );
};
